import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useMetricsTableStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        border: `${tokens.strokeWidthThin} solid`,
        borderRadius: tokens.borderRadiusLarge,
        overflowY: 'auto',
        height: 'fit-content',
        maxHeight: '330px',
        ...shorthands.borderColor(tokens.colorNeutralStroke1),
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '4px',
        borderBottom: `${tokens.strokeWidthThick} solid`,
        borderBottomColor: tokens.colorBrandStroke2,
    },
    tableBody: {
        display: 'table',
    },
    row: {
        display: 'table-row',

        '&.hoverable': {
            ':hover': {
                cursor: 'pointer',
            },
        },
    },
    currentRangeRow: {
        '&.even': {
            backgroundColor: tokens.colorNeutralBackground1,

            '&.hoverable': {
                ':hover': {
                    backgroundColor: tokens.colorNeutralBackground1Hover,
                },
            },
        },
        '&.odd': {
            backgroundColor: tokens.colorBrandBackground2,

            '&.hoverable': {
                ':hover': {
                    backgroundColor: tokens.colorBrandBackground2Hover,
                },
            },
        },
    },
    previousRangeRow: {
        '&.even': {
            backgroundColor: tokens.colorNeutralBackground1,

            '&.hoverable': {
                ':hover': {
                    backgroundColor: tokens.colorNeutralBackground1Hover,
                },
            },
        },
        '&.odd': {
            backgroundColor: tokens.colorNeutralBackground3,

            '&.hoverable': {
                ':hover': {
                    backgroundColor: tokens.colorNeutralBackground3Hover,
                },
            },
        },
    },
    cell: {
        display: 'table-cell',
        padding: '4px',
        verticalAlign: 'middle',

        '& > *': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
            gap: '4px',
        },
    },
    keyCell: {
        '& > *': {
            justifyContent: 'start',
        },

        '& svg': {
            minHeight: '1.125rem',
            minWidth: '1.125rem',
        },
    },
    trendCell: {
        paddingRight: '16px',
        width: '1px',

        '& > *': {
            justifyContent: 'end',
        },

        '& svg': {
            width: '1rem',
            height: '1rem',
        },
    },
    trendValue: {
        display: 'flex',
        alignItems: 'center',
        fill: tokens.colorNeutralForeground2,
        color: tokens.colorNeutralForeground2,

        '&.up': {
            fill: tokens.colorStatusSuccessBackground3,
            color: tokens.colorStatusSuccessBackground3,
        },

        '&.down': {
            fill: tokens.colorStatusDangerBackground3,
            color: tokens.colorStatusDangerBackground3,
        },
    },
});
